import { useNavigationMenuConfigQuery } from '~/api/navigationMenu'
import { AssistantSparkle } from '~/assistant/icons'
import { useMsg } from '~/common/localizationUtils'
import { IconButton, useDisclosure } from '~/design_system'
import { ChatProvider } from './ChatContext'
import { AssistantDrawer } from './components/AssistantDrawer'

type AssistantMenuButtonProps = {
  size?: 'xs' | 'sm' | 'md' | 'lg'
  'data-testid'?: string
}

export const AssistantMenuButton = ({
  size = 'md',
  'data-testid': dataTestId = 'assistant-menu-button'
}: AssistantMenuButtonProps) => {
  const { data: navConfig } = useNavigationMenuConfigQuery()
  const { isOpen, onClose, onToggle } = useDisclosure()
  const msg = useMsg()

  if (!navConfig?.is_vndly_assistant_chat_enabled) {
    return null
  }

  return (
    <>
      <IconButton
        aria-label={msg('assistant.ai.open_chat')}
        icon={<AssistantSparkle w={5} h={5} />}
        variant="mainMenu"
        size={size}
        borderRadius="full"
        data-testid={dataTestId}
        onClick={onToggle}
        bg={isOpen ? 'white' : 'base.blue950'}
        color={isOpen ? 'black' : 'white'}
        sx={{
          '@media print': { display: 'none' },
          boxShadow: isOpen
            ? '0 0 4.9px #ffc2fd, 0 0 0.98px #fff3a8, 0 0 1.96px #fec10b, 0 0 2.94px #fec10b, 0 0 4.9px #fd7e00, 0 0 7.36px #fc5b05, 0 0 9.81px #ffc2fd, 0 0 12.26px rgba(255, 194, 253, .5) !important'
            : 'none !important',
          _hover: {
            bg: isOpen ? 'white' : 'blue.600',
            color: '#fd7e00'
          }
        }}
      />
      <ChatProvider>
        <AssistantDrawer isOpen={isOpen} onClose={onClose} />
      </ChatProvider>
    </>
  )
}
